import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { Microphone, Stop, ArrowClockwise } from '@phosphor-icons/react';
import { createRecorder } from '@/lib/voice';

// Mic button that appends transcribed speech to a field. onText(text) receives the transcript.
export default function DictateButton({ onText, testid = 'dictate-btn', label = 'dictate' }) {
  const [state, setState] = useState('idle'); // idle | recording | working
  const rec = useRef(null);

  const toggle = async () => {
    if (state === 'working') return;
    if (state === 'idle') {
      try {
        rec.current = createRecorder();
        await rec.current.start();
        setState('recording');
      } catch {
        toast.error('Microphone blocked — allow mic access to dictate');
      }
      return;
    }
    // recording -> stop & transcribe
    setState('working');
    try {
      const text = await rec.current.stop();
      if (text) { onText(text); toast.success('Transcribed'); }
      else toast.error('Didn\'t catch that — try again');
    } catch {
      toast.error('Transcription failed');
    } finally {
      setState('idle');
    }
  };

  const Icon = state === 'recording' ? Stop : state === 'working' ? ArrowClockwise : Microphone;
  return (
    <button type="button" onClick={toggle} data-testid={testid}
      className={`inline-flex items-center gap-2 border px-3 py-2 text-[10px] uppercase tracking-[0.2em] transition-colors ${
        state === 'recording' ? 'border-red-500 bg-red-500/15 text-red-300 animate-pulse'
          : 'border-zinc-800 text-zinc-400 hover:border-emerald-500 hover:text-emerald-400'}`}>
      <Icon weight="bold" className={`h-4 w-4 ${state === 'working' ? 'animate-spin' : ''}`} />
      {state === 'recording' ? 'tap to stop' : state === 'working' ? 'transcribing…' : label}
    </button>
  );
}
